import React, { useState, useRef, useMemo,useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import JoditEditor from 'jodit-react';
import {
  Button,
  TextField,
  Grid,
  Box,
  FormHelperText
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const AddBroadCast = ({
  handleClose,
  openDialog,
  onSubmitBroadCast,
  register,
  handleSubmit,
  errors,
  placeholder,
  setBroadCastDataCont,
  setFile,
  editorNoVal,
  setValue
  
}) => {
  const editor = useRef(null);
  const [content, setContent] = useState('');

  const config = useMemo(() =>
  ({
    readonly: false, // all options from https://xdsoft.net/jodit/doc/,
    statusbar :false,
    placeholder: placeholder || 'Start typings...',
    removeButtons: ['image','video','link','print','about','source','strikethrough','brush','dots','ul',
    'ol'],
    toolbarButtonSize :'small',
   // extraButtons:['underline','outdent', 'indent','font','fontsize','hr','preview','copyformat'],
   extraButtons:['underline','outdent', 'indent','font','hr','preview'],
    // buttonsXS:['underline']
    
    
    
  }),
    [placeholder]
  );
  useEffect(()=>{
    setContent('')
  },[handleClose])
  return (
    <>
      <Dialog className="broadCastModel" open={openDialog} onClose={handleClose}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>Add BroadCast</b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 3 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={1}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid container sx={{ mb: 2 }}>
                      <Grid item xs={12}>
                        <TextField
                          className="stepperFormInput"
                          label="Broadcast Title"
                          name="title"
                          placeholder="Title"
                          fullWidth
                          required
                          size="small"
                          autoComplete="off"
                          {...register("title", { required: true })}
                          error={Boolean(errors?.title)}
                          helperText={errors?.title?.message}
                          onBlur={(e) => {
                            let str = e.target.value;
                            setValue("title", str.trim());
                           
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mb: 2 }}>
                      <Grid item xs={12}>
                        <JoditEditor
                          ref={editor}
                          value={content}
                          config={config}
                          tabIndex={1} // tabIndex of textarea
                         // onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                          onChange={newContent => { setBroadCastDataCont(JSON.stringify(newContent))}}
                        />
                        <FormHelperText error>
                            {editorNoVal
                              ? "This field is required"  
                              : null}
                          </FormHelperText>

                      </Grid>
                      <input
                        type="file"
                        accept="application/pdf,.docx,.doc,.xls, .xlsx, .csv"
                        id="upload-button"
                        style={{ width: "240px",marginTop:"15px" }}
                        onChange={(e) => setFile(e.target.files[0])}
                      />

                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2,justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onSubmitBroadCast)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
              
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddBroadCast;
